"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NotePopover;
var _react = _interopRequireWildcard(require("react"));
var _icons = require("@material-ui/icons");
var _NoteAdd = _interopRequireDefault(require("@material-ui/icons/NoteAdd"));
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _core = require("@material-ui/core");
var _contexts = require("../../contexts");
var _copy = require("../../constants/copy");
var _services = require("../../services");
var _themes = require("../../themes");
var _styles = _interopRequireDefault(require("./styles"));
var _utils = require("../../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /* eslint-disable react/jsx-no-bind */
var POPOVER_STATE_KEY = '__notePopover';
function NotePopover() {
  var [popoverHeight, setPopoverHeight] = (0, _react.useState)(276);
  var classes = (0, _styles.default)();
  var transformOriginBottom = {
    vertical: 'top',
    horizontal: 'right'
  };
  var transformOriginUp = {
    vertical: 'bottom',
    horizontal: 'right'
  };
  var {
    highlightColor,
    setHighlightColor,
    handleCardColorClick,
    anchorPositionAnnotationPopover,
    setAnchorPositionAnnotationPopover,
    highlights,
    handleHighlightClose,
    isDraft,
    contents
  } = (0, _react.useContext)(_contexts.HighlightsContext);
  var {
    setOpenDrawer,
    selectTab,
    setSelectedAnnotation
  } = (0, _react.useContext)(_contexts.SideBarContext);
  var {
    isCopyrightWarnDisable,
    setOpenCopyrightDialog,
    setOpenCopyTextDialog,
    setCopyValue,
    setOpenCopyrightLimitDialog,
    setReference,
    getPercentageCharsCopied,
    setCopyOrigin
  } = (0, _react.useContext)(_contexts.CopyrightContext);
  var {
    sessionToken,
    uuid,
    bookTitle
  } = (0, _react.useContext)(_contexts.EpubReaderContext);
  var appToken = (0, _utils.appTokenCase)(window.location.origin);
  var service = (0, _services.TrackingsService)(appToken, sessionToken);
  (0, _react.useEffect)(() => {
    if (anchorPositionAnnotationPopover) {
      window.history.pushState({
        [POPOVER_STATE_KEY]: true
      }, '');
    }
  }, [anchorPositionAnnotationPopover]);
  (0, _react.useEffect)(() => {
    function onPopState() {
      if (anchorPositionAnnotationPopover) {
        var _contents$window;
        setAnchorPositionAnnotationPopover();
        setHighlightColor();
        contents === null || contents === void 0 || (_contents$window = contents.window) === null || _contents$window === void 0 || (_contents$window = _contents$window.getSelection()) === null || _contents$window === void 0 || _contents$window.removeAllRanges();
      }
    }
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, [anchorPositionAnnotationPopover, contents, setAnchorPositionAnnotationPopover, setHighlightColor]);
  function trackingAddNote() {
    return _trackingAddNote.apply(this, arguments);
  }
  function _trackingAddNote() {
    _trackingAddNote = _asyncToGenerator(function* () {
      var highlight = highlights.current[highlights.current.length - 1];
      yield service.trackAddBooknote({
        uuid,
        titleCover: bookTitle,
        origin: 'clicou no Botão de Adicionar Nota',
        color: highlight.color,
        id: highlight.id,
        booknote: highlight.annotation ? 'yes' : 'no',
        highlight: highlight.textHighlighted
      });
    });
    return _trackingAddNote.apply(this, arguments);
  }
  function noteAddOpenMenu() {
    var highlight = highlights.current[highlights.current.length - 1];
    setOpenDrawer(true);
    selectTab(1);
    trackingAddNote();
    setSelectedAnnotation({
      cfiRange: highlight.textReference
    });
  }
  function noteAdd() {
    return _noteAdd.apply(this, arguments);
  }
  function _noteAdd() {
    _noteAdd = _asyncToGenerator(function* () {
      if (isDraft) yield handleCardColorClick('green');
      handleClosePopover();
      noteAddOpenMenu();
    });
    return _noteAdd.apply(this, arguments);
  }
  var handleClosePopover = () => {
    var _window$history$state;
    if ((_window$history$state = window.history.state) !== null && _window$history$state !== void 0 && _window$history$state[POPOVER_STATE_KEY]) {
      window.history.replaceState(null, '');
    }
    setAnchorPositionAnnotationPopover();
    setHighlightColor();
    handleHighlightClose();
  };
  function renderHighlightColors() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.noteColor
    }, /*#__PURE__*/_react.default.createElement(_saraivaUi.CardSelect, {
      label: "Verde",
      backgroundColor: _themes.HIGHLIGHT_COLORS.green,
      onClick: /*#__PURE__*/_asyncToGenerator(function* () {
        handleCardColorClick('green');
      }),
      selected: highlightColor === 'green'
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.colorSpacing
    }), /*#__PURE__*/_react.default.createElement(_saraivaUi.CardSelect, {
      label: "Amarelo",
      backgroundColor: _themes.HIGHLIGHT_COLORS.yellow,
      onClick: /*#__PURE__*/_asyncToGenerator(function* () {
        handleCardColorClick('yellow');
      }),
      selected: highlightColor === 'yellow'
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.colorSpacing
    }), /*#__PURE__*/_react.default.createElement(_saraivaUi.CardSelect, {
      label: "Vermelho",
      backgroundColor: _themes.HIGHLIGHT_COLORS.red,
      onClick: /*#__PURE__*/_asyncToGenerator(function* () {
        handleCardColorClick('red');
      }),
      selected: highlightColor === 'red'
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.colorSpacing
    }), /*#__PURE__*/_react.default.createElement(_saraivaUi.CardSelect, {
      label: "Roxo",
      backgroundColor: _themes.HIGHLIGHT_COLORS.purple,
      onClick: /*#__PURE__*/_asyncToGenerator(function* () {
        handleCardColorClick('purple');
      }),
      selected: highlightColor === 'purple'
    }));
  }
  function isPopoverOverAnnotation() {
    var popoverBottom = anchorPositionAnnotationPopover === null || anchorPositionAnnotationPopover === void 0 ? void 0 : anchorPositionAnnotationPopover.bottom;
    var windowHeight = window.innerHeight;
    return popoverBottom > windowHeight - popoverHeight;
  }
  function getAnchorPosition() {
    if (!anchorPositionAnnotationPopover) return null;
    var {
      right,
      bottom,
      top
    } = anchorPositionAnnotationPopover;
    return {
      left: right,
      top: isPopoverOverAnnotation() ? top : bottom
    };
  }
  function getTransformOrigin() {
    return isPopoverOverAnnotation() ? transformOriginUp : transformOriginBottom;
  }
  function handlePopoverRef(el) {
    var _el$querySelector;
    var newPopoverHeight = el === null || el === void 0 || (_el$querySelector = el.querySelector('.makeStyles-rootPopover-3')) === null || _el$querySelector === void 0 ? void 0 : _el$querySelector.clientHeight;
    if (newPopoverHeight > 0) setPopoverHeight(newPopoverHeight);
  }
  var openCopyDialog = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(function* () {
      var checkCopyright = yield isCopyrightWarnDisable();
      var copyValue = yield getPercentageCharsCopied();
      setCopyValue(copyValue);
      if (copyValue >= 100) {
        setOpenCopyrightLimitDialog(true);
      } else if (checkCopyright && copyValue < 100) {
        setOpenCopyTextDialog(true);
      } else if (!checkCopyright && copyValue < 100) {
        setOpenCopyrightDialog(true);
      }
    });
    return function openCopyDialog() {
      return _ref5.apply(this, arguments);
    };
  }();
  var handleCopyFlow = () => {
    var _contents$window2;
    var selection = contents === null || contents === void 0 || (_contents$window2 = contents.window) === null || _contents$window2 === void 0 || (_contents$window2 = _contents$window2.getSelection()) === null || _contents$window2 === void 0 || (_contents$window2 = _contents$window2.toString()) === null || _contents$window2 === void 0 ? void 0 : _contents$window2.trim();
    var lastHighlight = highlights.current[highlights.current.length - 1];
    setReference(selection || lastHighlight.textHighlighted);
    setCopyOrigin(_copy.ORIGIN.READER);
    handleClosePopover();
    openCopyDialog();
  };
  return /*#__PURE__*/_react.default.createElement(_core.Popover, {
    open: Boolean(anchorPositionAnnotationPopover),
    onClose: handleClosePopover,
    anchorReference: "anchorPosition",
    anchorPosition: getAnchorPosition(),
    transformOrigin: getTransformOrigin(),
    classes: {
      paper: classes.rootPopover
    },
    ref: handlePopoverRef
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.popoverTitle,
    variant: "h6",
    color: "textSecondary"
  }, "Op\xE7\xF5es", /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: handleClosePopover,
    className: classes.popoverClose
  }, /*#__PURE__*/_react.default.createElement(_icons.CloseSharp, null))), /*#__PURE__*/_react.default.createElement(_core.Divider, null), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.popoverActions
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.btn,
    onClick: handleCopyFlow
  }, /*#__PURE__*/_react.default.createElement(_icons.FileCopy, {
    className: classes.icon
  }), "Copiar"), /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.btn,
    onClick: noteAdd
  }, /*#__PURE__*/_react.default.createElement(_NoteAdd.default, {
    className: classes.icon
  }), "Adicionar nota")), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.popoverText,
    color: "textPrimary"
  }, "Cor do Destaque"), renderHighlightColors());
}